//
//
//
//

import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";

export default {
    components: {
        AQBadge
    },
    props: {
        status: {
            type: String,
            default: ""
        }
    }
};
